import { FiAlertCircle } from '@react-icons/all-files/fi/FiAlertCircle'
import { IoIosAlert } from '@react-icons/all-files/io/IoIosAlert'

// alert, error, warning situations

export const IconAlert = FiAlertCircle
export const IconAlertFill = IoIosAlert
